import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const DASHBOARD_TEMPLATE_MESSAGES = {
  CREATE: "Crear plantilla de dashboard",
  CANCEL: "Cancelar plantilla de dashboard",
  USED_FIELD: "Este campo ya esta seindo utilizado",
  MUST_CHOOSE_TEMPLATE: "Primero debe elegir una plantilla",
  THERE_ARE_FIELDS_THAT_DEPEND_ON_TEMPLATE:
    "Hay campos que dependen de la plantilla",
  CHOOSE_OPERATION: "Elegir operación",
  CHOOSE_TAG: "Elegir etiqueta",
  INDICATOR_NAME_REPEATED: "Ya existe un indicador con el mismo nombre",
  TAG_NAME_REPEATED: "Ya existe una etiqueta con el mismo nombre",
  GROUP_BY: "Agrupar por",
  SEE_BY: "Ver por",
  CANT_GROUP_BY_DATE: "No puede agrupar por dos fechas",
  TAG_IN_USE:
    "No se puede eliminar la etiqueta porque esta siendo usada en un indicador",
  CHOOSE_SELECTOR_FIELD_TO_OPERATE: "Elegir selector para operar"
};

export const DASHBOARD_TEMPLATE_EVENTS = {
  DELETE_CHART: "deleteChart",
  SPECIAL_FIELD_SELECTED: "specialFieldSelected",
  SAVE_FILTER_SECTION: "saveFilterSection",
  CANCEL_FILTER_SECTION: "cancelFilterSection",
  SET_TOTAL_FILTERS: "setTotalFilters",
  REDUCE_TOTAL_FILTERS: "reduceTotalFilters",
  RELOAD_QUERIES: "reloadQueries",
  DELETE_FILTER: "deleteFilter",
  SET_FILTER_ITEM: "setFilterItem",
  SET_ACTIONS_IN_FILTERS: "setActionInFilters",
  UPDATE_QUERY: "updateQuery",
  ADD_FILTER: "addFilter",
  SAVE_FILTER: "saveFilter",
  CANCEL_FILTER: "cancelFilter",
  CLOSE_INDICATOR_MODAL: "closeIndicatorModal",
  QUITE_COLLECTION_ITEM_OPTION_AND_PUT_IN_COLLECTION:
    "quitCollectionItemOptionAndPutInCollection",
  DELETE_COLLECTION: "deleteCollection",
  SET_COLLECTION_ITEM: "setCollectionItem",
  SET_CONFIG_CHART: "setConfigChart",
  SET_QUERY: "setQuery",
  SET_CHART_TYPE: "setChartType",
  SET_SECTIONS_OF_DASHBOARD: "setSectionsOfDashboard",
  TEMPLATE_SAVED: "templateSaved",
  UPDATE_SECTIONS_OF_DASHBOARD: "updateSectionsOfDashboard",
  CLEAN_ALL_DATA_OF_DASHBOARD_TEMPLATE: "cleanAllDataOfDashboardTemplate",
  ADD_COLLECTION_TO_SECTION_OF_DASHBOARD: "addCollectionToSectionOfDashboard",
  UPDATE_SECTION_NAME_OF_DASHBOARD: "updateSectionNameOfDashboard",
  DELETE_SECTION_OF_DASHBOARD: "deleteSectionOfDashboard",
  SET_COLLECTIONS_OPTIONS: "setCollectionsOptions",
  SET_TAGS: "setTags",
  ADD_TAG: "addTag",
  UPDATE_TAG: "updateTag",
  DELETE_TAG: "deleteTag",
  SET_INDICATORS: "setIndicators",
  ADD_INDICATOR: "addIndicator",
  UPDATE_INDICATOR: "updateIndicator",
  DELETE_INDICATOR: "deleteIndicator",
  UPDATE_GROUP_BY: "updateGroupBy",
  CHANGE_COLLECTION_FIELD: "changeCollectionField",
  DELETE_FIELD_IN_STORE: "deleteFieldInStore",
  SET_FIELDS_TO_STORE: "setFieldsToStore",
  SET_FETCH_DATA: "setFetchData",
  SHOW_LOADING_BAR: "showLoadingBar"
};

export const DATA_TYPE = {
  HTML: "html",
  TIME_STAMP: "timestamp",
  LIST: "list",
  LISTA: "lista",
  NUMBER: "number",
  STRING: "string",
  TIME_UNIT: "timeUnit",
  TEXT: "text",
  DATE: "date",
  FIRST_FORM: "firstForm",
  LAST_FORM: "lastForm",
  SECOND_TO_LAST_FORM: "secondToLastForm"
};

export const DASHBOARD_OPERATORS = {
  BETWEEN: "Entre",
  RANGE: "Rango de fechas"
};

export const DASHBOARD_OPERATORS_TO_QUERY = {
  BETWEEN: "BETWEEN",
  RANGE: "range"
};

export const TIME_UNITS_LIST = {
  LAST_HOURS: "lastHours",
  LAST_DAYS: "lastDays",
  LAST_WEEKS: "lastWeeks",
  LAST_MONTHS: "lastMonths",
  LAST_YEARS: "lastYears",
  NEXT_HOURS: "nextHours",
  NEXT_DAYS: "nextDays",
  NEXT_WEEKS: "nextWeeks",
  NEXT_MONTHS: "nextMonths",
  NEXT_YEARS: "nextYears"
};

export const RANGE_OPERATORS_LIST = [
  { id: TIME_UNITS_LIST.LAST_HOURS, name: "Últimas horas" },
  { id: TIME_UNITS_LIST.LAST_DAYS, name: "Últimos días" },
  { id: TIME_UNITS_LIST.LAST_WEEKS, name: "Últimas semanas" },
  { id: TIME_UNITS_LIST.LAST_MONTHS, name: "Últimos meses" },
  { id: TIME_UNITS_LIST.LAST_YEARS, name: "Últimos años" },
  { id: TIME_UNITS_LIST.NEXT_HOURS, name: "Próximas horas" },
  { id: TIME_UNITS_LIST.NEXT_DAYS, name: "Próximos días" },
  { id: TIME_UNITS_LIST.NEXT_WEEKS, name: "Próximas semanas" },
  { id: TIME_UNITS_LIST.NEXT_MONTHS, name: "Próximos meses" },
  { id: TIME_UNITS_LIST.NEXT_YEARS, name: "Próximos años" }
];

export const DASHBOARD_OPERATIONS = {
  COUNT: "COUNT"
};

export const DASHBOARD_FIELDS = {
  DOC_ID: "docId"
};

export const DASHBOARD_TEMPLATES_TITLE = "Consulta de plantillas de dashboard";

export const CHARTS_COLORS = [
  "#63c7e7", // color inicial (celeste claro)
  "#4aa9d4",
  "#368cbf",
  "#2b6fa4",
  "#235388",
  "#1b396b",
  "#0b3352" // color final (azul profundo)
];

export const DASHBOARD_TEMPLATE_EMPTY = [
  {
    name: "",
    tags: [],
    indicators: [],
    collectionsOptions: [],
    collections: [
      {
        collection: [{ id: "", name: "", fields: [] }],
        filters: [],
        groupBy: [],
        seeBy: [],
        chartName: "",
        query: {
          selectFields: {
            agregations: [],
            fields: []
          },
          principalView: "",
          filters: [],
          groupFields: []
        },
        chartData: {},
        chartType: "",
        chartColor: ""
      }
    ]
  }
];

export const DASHBOARD_TEMPLATE_FILTERS = {
  MAIN: {
    mainFilterKey: "Plantilla de dashboard",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    initial: true,
    secondaryFilters: [] as SecondaryFilter[],
    placeholder: "Escriba el nombre de la plantilla de Dashboard"
  },
  SECONDARY: {
    NAME: {
      name: "Nombre",
      placeholder: "Nombre de plantilla",
      key: "name",
      avatar: "mdi-form-textbox",
      type: "secondaryFilter",
      default: true,
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "unique"
    }
  }
};

export const INDICATOR = "indicator";
export const TAG = "tag";

export const DASHBOARD_OPERATIONS_LIST = [
  { id: "+", name: "Sumar" },
  { id: "-", name: "Restar" },
  { id: "/", name: "Dividir" },
  { id: "*", name: "Multiplicar" }
];

export const DASHBOARD_OPERATIONS_TAGAS = [
  { id: "COUNT", name: "Conteo de registros" },
  { id: "AVG", name: "Promedio" },
  { id: "MIN", name: "Mínimo" },
  { id: "MAX", name: "Máximo" },
  { id: "SUM", name: "Sumar" }
];

export const SEE_BY_LIST = [
  { id: "hour", name: "Hora" },
  { id: "day", name: "Día" },
  { id: "week", name: "Semana" },
  { id: "month", name: "Mes" },
  { id: "year", name: "Año" }
];

export const FIELD_WITHOUT_DATA_ID = "Ninguno(a)";
export const FIELD_WITHOUT_DATA = {
  id: FIELD_WITHOUT_DATA_ID,
  name: FIELD_WITHOUT_DATA_ID
};

export const DEFAULT_COLOR = "#00000000";

export const COLLECTIONS_BIGQUERY = {
  FORMS: "forms"
};

export const USER_ID_FIELD = "userId";

export const EXCLUDE_FIELDS = ["dateStateHistory", "stateStateHistory"];
export const BIGQUERY_CACHE_TYPES = {
  CHART: "chart",
  TAG: "tag"
};

export const SPECIAL_FIELDS = [
  "firstForm",
  "lastForm",
  "secondToLastForm",
  "firstAndLastForm",
  "twoLastForms",
  "firstService",
  "lastService",
  "secondToLastService",
  "firstAndLastService",
  "twoLastServices"
];

export const SPECIAL_FIELDS_LIST = [
  SPECIAL_FIELDS[0],
  SPECIAL_FIELDS[1],
  SPECIAL_FIELDS[2],
  SPECIAL_FIELDS[5],
  SPECIAL_FIELDS[6],
  SPECIAL_FIELDS[7]
];

export const SPECIAL_FIELDS_VALUES = [
  "Primer formulario",
  "Último formulario",
  "Penúltimo formulario",
  "Primer y último formulario",
  "Dos últimos formularios",
  "Primer servicio",
  "Último servicio",
  "Penúltimo servicio",
  "Primer y último servicio",
  "Dos últimos servicios"
];

export const SPECIAL_FIELDS_IDS = {
  FIRST: "FIRST",
  LAST: "LAST",
  SECOND_TO_LAST: "SECOND_TO_LAST"
};

export const SPECIAL_FIELDS_MAP: Record<
  string,
  { key: string; finalValue: string }
> = SPECIAL_FIELDS_VALUES.reduce((acc, finalValue, index) => {
  acc[finalValue] = { key: SPECIAL_FIELDS[index], finalValue: finalValue };
  return acc;
}, {} as Record<string, { key: string; finalValue: string }>);

export const SPECIAL_FIELDS_DATA: Record<
  string,
  { data: { id: string; name: string }[] }
> = {
  firstForm: {
    data: [{ id: SPECIAL_FIELDS_IDS.FIRST, name: SPECIAL_FIELDS_VALUES[0] }]
  },
  lastForm: {
    data: [{ id: SPECIAL_FIELDS_IDS.LAST, name: SPECIAL_FIELDS_VALUES[1] }]
  },
  secondToLastForm: {
    data: [
      {
        id: SPECIAL_FIELDS_IDS.SECOND_TO_LAST,
        name: SPECIAL_FIELDS_VALUES[2]
      }
    ]
  },
  firstAndLastForm: {
    data: [
      {
        id: SPECIAL_FIELDS_IDS.FIRST,
        name: SPECIAL_FIELDS_VALUES[0]
      },
      { id: SPECIAL_FIELDS_IDS.LAST, name: SPECIAL_FIELDS_VALUES[1] }
    ]
  },
  twoLastForms: {
    data: [
      {
        id: SPECIAL_FIELDS_IDS.SECOND_TO_LAST,
        name: SPECIAL_FIELDS_VALUES[2]
      },
      { id: SPECIAL_FIELDS_IDS.LAST, name: SPECIAL_FIELDS_VALUES[1] }
    ]
  },
  firstService: {
    data: [{ id: SPECIAL_FIELDS_IDS.FIRST, name: SPECIAL_FIELDS_VALUES[5] }]
  },
  lastService: {
    data: [{ id: SPECIAL_FIELDS_IDS.LAST, name: SPECIAL_FIELDS_VALUES[6] }]
  },
  secondToLastService: {
    data: [
      {
        id: SPECIAL_FIELDS_IDS.SECOND_TO_LAST,
        name: SPECIAL_FIELDS_VALUES[7]
      }
    ]
  },
  firstAndLastService: {
    data: [
      {
        id: SPECIAL_FIELDS_IDS.FIRST,
        name: SPECIAL_FIELDS_VALUES[5]
      },
      { id: SPECIAL_FIELDS_IDS.LAST, name: SPECIAL_FIELDS_VALUES[6] }
    ]
  },
  twoLastServices: {
    data: [
      {
        id: SPECIAL_FIELDS_IDS.SECOND_TO_LAST,
        name: SPECIAL_FIELDS_VALUES[7]
      },
      { id: SPECIAL_FIELDS_IDS.LAST, name: SPECIAL_FIELDS_VALUES[6] }
    ]
  }
};
